import React, { Component } from "react";
import Header from "../../components/header/Header";
import { degrees, certifications, competitiveSites } from "../../portfolio.js";
import { handleLandingScroll } from "../../utils/scroll";
import { trackPageview } from "../../utils/analytics";

function bulletText(s) { return s.replace(/^⚡\s*/, ""); }

function Degree({ d }) {
  const parts = (d.subtitle || "").split(",");
  const level = (parts[0] || "").trim();
  const field = (parts[1] || "").trim();
  return (
    <div className="role-block">
      <div className="when">
        <b>{d.duration}</b>
        <span className="where">CASABLANCA · {d.alt_name || ""}</span>
      </div>
      <div>
        <h3>{level} {field ? <em>{field}</em> : null}</h3>
        <div className="where-line">
          <a className="inline" href={d.website_link} target="_blank" rel="noopener noreferrer">
            <b>{d.title}</b>
          </a>
        </div>
        {(d.descriptions || []).map((line, i) => (
          <p key={i}>{bulletText(line)}</p>
        ))}
      </div>
      <div className="side"></div>
    </div>
  );
}

function CertCell({ c, n }) {
  return (
    <div className="cert-cell">
      <div className="num">CERT {n}</div>
      <h4>{c.title.toUpperCase()}</h4>
      <div className="by">
        {(c.subtitle || "").replace(/^-\s*/, "")} · {c.alt_name}
        <br/>
        <a href={c.certificate_link} target="_blank" rel="noopener noreferrer">→ VIEW CREDENTIAL</a>
      </div>
    </div>
  );
}

class Education extends Component {
  componentDidMount() {
    handleLandingScroll(this.props.location);
    trackPageview();
  }
  render() {
    const degs = degrees.degrees || [];
    const certs = certifications.certifications || [];
    const platforms = (competitiveSites.competitiveSites || []).map((s) => s.siteName);

    return (
      <>
        <div className="grid-bg" />
        <Header theme={this.props.theme} />

        <div className="wrap">

          {/* HERO */}
          <section className="hero">
            <div className="label-strip">
              <span><b>ACADEMIC LINE</b></span>
              <span>{degs.length} DEGREES · {certs.length} CERTS</span>
              <span><b>2013</b> → 2020</span>
            </div>

            <h1 className="huge">
              <span className="row">MATHS,</span>
              <span className="row indent">then <span className="ital">data</span>.</span>
            </h1>

            <div className="sub-row">
              <p>
                Came into engineering through <b>pure mathematics</b> — which
                mostly means I'm patient with proofs and impatient with
                frameworks that hide them. The data-engineering master's is
                where it became practical.
              </p>
              <div className="meta-block">
                <div className="k">RECORD</div>
                <div className="row"><span className="lab">DEGREES</span><span>{degs.length}</span></div>
                <div className="row"><span className="lab">CERTS</span><span>{certs.length}</span></div>
                <div className="row"><span className="lab">CITY</span><span>CASABLANCA</span></div>
                <div className="row"><span className="lab">LANGUAGES</span><span>FR · AR · EN</span></div>
              </div>
            </div>
          </section>

          {/* DEGREES */}
          <section className="section" id="degrees">
            <div className="section-head">
              <h2 className="section-title">01 <em>·</em> DEGREES</h2>
              <div className="meta"><b>{degs.length}</b><br/>EARNED</div>
            </div>

            <div className="role-list">
              {degs.map((d) => <Degree key={d.title + d.duration} d={d} />)}
            </div>
          </section>

          {/* CERTIFICATIONS */}
          <section className="section" id="certifications">
            <div className="section-head">
              <h2 className="section-title">02 <em>·</em> CERTIFICATIONS</h2>
              <div className="meta"><b>{certs.length}</b><br/>COMPLETED</div>
            </div>

            <div className="cert-grid">
              {certs.map((c, i) => <CertCell key={c.title} c={c} n={String(i + 1).padStart(2, "0")} />)}
            </div>
          </section>

          {/* PLATFORMS */}
          <section className="section" style={{ borderBottom: 0 }}>
            <div className="section-head">
              <h2 className="section-title">03 <em>·</em> PLATFORMS</h2>
              <div className="meta">ONGOING<br/><b>LEARNING</b></div>
            </div>

            <p style={{ fontSize: 17, lineHeight: 1.7, maxWidth: "62ch" }}>
              Where most of the ongoing learning happens:{" "}
              {platforms.map((p, i) => (
                <span key={p}>
                  <b>{p}</b>{i < platforms.length - 1 ? " · " : ""}
                </span>
              ))}.
            </p>

            <p style={{ fontFamily: "'Space Grotesk', sans-serif", fontStyle: "italic", fontSize: 22, lineHeight: 1.4, maxWidth: "50ch", marginTop: 32, borderLeft: "3px solid var(--accent)", paddingLeft: 20 }}>
              "The most useful thing I learned in school was <b>patience</b> —
              every interesting problem looks unapproachable for a while
              before it doesn't."
            </p>
          </section>
        </div>

        {/* CONTACT SLAB */}
        <div className="wrap">
          <div className="foot-slab">
            <div className="inner">
              <h2>BUILT ON <em>maths,</em><br/>SHIPPED IN <em>code.</em></h2>
              <div>
                <p>Pure-mathematics foundation, data-engineering specialization. The combination shows up in the code.</p>
                <div className="links">
                  <a href="#/cv">→ FULL CV</a>
                  <a href="mailto:maaninou.walid@gmail.com">→ EMAIL</a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <footer className="site-footer">
          <span>© 2026 MAANINOU WALID · CASABLANCA · GMT+1</span>
          <span>
            <a href="mailto:maaninou.walid@gmail.com">EMAIL</a>
            <a href="https://github.com/walidMaaninou">GITHUB</a>
            <a href="https://www.linkedin.com/in/walid-maaninou-86a844102/">LINKEDIN</a>
          </span>
        </footer>
      </>
    );
  }
}

export default Education;
